import { render, staticRenderFns } from "./ModuleCreate.vue?vue&type=template&id=5ad60760"
import script from "./ModuleCreate.vue?vue&type=script&lang=js"
export * from "./ModuleCreate.vue?vue&type=script&lang=js"
import style0 from "./ModuleCreate.vue?vue&type=style&index=0&id=5ad60760&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports